import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "../../../../../utility/commonServices";
import { APIROUTES } from "../../../../../routes/apiRoutes";
import {
  GET_INSURANCE_PRODUCT_SEARCH_LIST,
  GET_INSURANCE_PRODUCT_LIST,
  POST_INSURANCE_PRODUCT_DATA,
  PATCH_INSURANCE_PRODUCT_DATA,
} from "../../../../../redux/actionTypes";

export const getInsuranceProductListMiddleWare = createAsyncThunk(
  GET_INSURANCE_PRODUCT_LIST,
  async (payload, { rejectWithValue, getState }) => {
    const { insuranceProductReducers } = getState();
    try {
      // const { data } = await getRequest(APIROUTES.DASHBOARD.GET_DETAILS);
      return payload;
    } catch (error) {
      return rejectWithValue(error?.response.data.error.message);
    }
  }
);

export const postInsuranceProductMiddleWare = createAsyncThunk(
  POST_INSURANCE_PRODUCT_DATA,
  async (payload, { rejectWithValue, getState }) => {
    const bodyTableData = {
      id: payload?.id,
      modifiedby: "Name",
      modifiedOn: "12/12/2023",
      Status: 0,
      productCode: payload?.productCode,
      productName: payload?.productName,
      commissionCode: "Com00123",
      lineofBusiness: payload?.lineofBusiness,
      description: payload?.productDescription,
      action: payload?.id,
    };
    console.log(bodyTableData, "find add datas in midd");

    try {
      // const { data } = await getRequest(APIROUTES.DASHBOARD.GET_DETAILS);
      return bodyTableData;
    } catch (error) {
      return rejectWithValue(error?.response.data.error.message);
    }
  }
);
export const patchInsuranceProductMiddleWare = createAsyncThunk(
  PATCH_INSURANCE_PRODUCT_DATA,
  async (payload, { rejectWithValue, getState }) => {
    console.log(payload, "find edit load");
    const { insuranceProductReducers } = getState();
    const { InsuranceProductList } = insuranceProductReducers;
    console.log(InsuranceProductList, "find original data");
    const updatedData = InsuranceProductList?.map((item) => {
      if (parseInt(item.id) === parseInt(payload?.id)) {
        return {
          ...item,
          productCode: payload?.productCode,
          productName: payload?.productName,
          lineofBusiness: payload?.productDescription,
          description: payload?.lineofBusiness,
        };
      }
      return item;
    });
    console.log(updatedData, "find updatedData");

    try {
      // const { data } = await getRequest(APIROUTES.DASHBOARD.GET_DETAILS);
      return updatedData;
    } catch (error) {
      return rejectWithValue(error?.response.data.error.message);
    }
  }
);
export const getSearchInsuranceProductMiddleware = createAsyncThunk(
  GET_INSURANCE_PRODUCT_SEARCH_LIST,
  async (payload, { rejectWithValue, getState }) => {
    const { textSearch } = payload;
    const { insuranceProductReducers } = getState();

    const { InsuranceProductList } = insuranceProductReducers;
    console.log(InsuranceProductList, "1234");

    try {
      if (textSearch.trim() !== "") {
        const searchResults = InsuranceProductList?.filter((item) => {
          return item.productCode
            .toLowerCase()
            .includes(textSearch.toLowerCase());
        });
        console.log(searchResults, "searchResults");
        return searchResults;
      } else {
        return InsuranceProductList;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.error?.message);
    }
  }
);
